import { useQuery } from "@apollo/client";
import {
  GetMeetingNewPageQueryQuery,
  GetMeetingNewPageQueryQueryVariables,
} from "types/graphql-schema";

import MeetingBot from "@apps/meeting-new/components/meeting-bot";
import {
  MeetingPageContent,
  MeetingPageContext,
} from "@apps/meeting-new/components/meeting-page";
import getMeetingQuery from "@apps/meeting-new/graphql/get-meeting-query";
import AppError from "@components/error/error";
import Loading from "@components/loading/loading";
import { classNames } from "@helpers/css";

const MeetingsOverviewSidebar = ({
  meetingId,
  hideMeetingBot = false,
}: {
  meetingId: number;
  hideMeetingBot?: boolean;
}) => {
  const { loading, data } = useQuery<
    GetMeetingNewPageQueryQuery,
    GetMeetingNewPageQueryQueryVariables
  >(getMeetingQuery, {
    variables: { meetingId },
  });
  const sidebarMeeting = data?.meeting;
  const sidebarMeetingGroup = sidebarMeeting?.meetingGroup;

  return (
    <div className="">
      {loading ? (
        <Loading size={5} className="p-6 text-sm">
          Loading meeting...
        </Loading>
      ) : sidebarMeetingGroup && sidebarMeeting ? (
        <div className={classNames("p-6", hideMeetingBot && "pt-0")}>
          {!hideMeetingBot && (
            <div className="w-full flex gap-4 items-center justify-between mb-4">
              <MeetingBot
                meeting={sidebarMeeting}
                statusClassName="flex-1 min-w-0 justify-end"
              />
            </div>
          )}
          <MeetingPageContext.Provider
            value={{
              isInExtension: false,
              isInSidebar: true,
            }}
          >
            <MeetingPageContent
              meetingGroupId={sidebarMeetingGroup.id}
              meeting={sidebarMeeting}
            />
          </MeetingPageContext.Provider>
        </div>
      ) : (
        <AppError title="Meeting not found" />
      )}
    </div>
  );
};

export default MeetingsOverviewSidebar;
